import { onResponseErrorMessage } from '@/model/global/utils';

export const onWithdrawalErrorMessage = (namespace: string, defaultMessageId: string): ((error: any) => Generator) =>
  onResponseErrorMessage(namespace, defaultMessageId, [
    '500.6.3.1.46',
    '500.6.3.1.46.1',
    '500.6.3.1.47',
    '500.6.3.1.48',
    '500.6.3.1.48.1',
  ]);
